import { Injectable } from '@angular/core';
import { BaseProvider } from '../../../../shared/providers/base-provider';
import { AnalysisNotifier } from './analysis-notifier';
import { AnalysisState } from './analysis-state';

@Injectable()
export class AnalysisProvider extends BaseProvider<AnalysisNotifier, AnalysisState> {
  constructor() {
    super(AnalysisNotifier);
  }
}
